// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "small-title-module--base-text-alt--global--dda62";
export var baseTextGlobal = "small-title-module--base-text--global--251cd";
export var blockSpacing100 = "small-title-module--block-spacing-100--fba79";
export var blockSpacing50 = "small-title-module--block-spacing-50--2ea3d";
export var blockVPadding100 = "small-title-module--block-v-padding-100--80db4";
export var blockVPadding50 = "small-title-module--block-v-padding-50--09df1";
export var captionTextGlobal = "small-title-module--caption-text--global--af9d1";
export var cmsRenderedContentGlobal = "small-title-module--cms-rendered-content--global--81713";
export var defaultHSpacingGlobal = "small-title-module--default-h-spacing--global--eecc9";
export var fadeInAnimation = "small-title-module--fadeInAnimation--8faa2";
export var fadeInOnLoadGlobal = "small-title-module--fade-in-on-load--global--7a842";
export var fullHeightGlobal = "small-title-module--full-height--global--7ca6f";
export var fullHeightOmittingNavGlobal = "small-title-module--full-height-omitting-nav--global--00ebd";
export var headingTextGlobal = "small-title-module--heading-text--global--8e4d0";
export var ingressTextGlobal = "small-title-module--ingress-text--global--910ff";
export var linkColorChangeTransitionGlobal = "small-title-module--link-color-change-transition--global--9e2c7";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "small-title-module--page-heading-text--global--70275";
export var paragraphTextGlobal = "small-title-module--paragraph-text--global--6c708";
export var subheadingTextGlobal = "small-title-module--subheading-text--global--111a5";
export var title = "small-title-module--title--f916d";